export interface SideBarOption {
  text: string;
  icon: string;
  link: string;
  children?: SideBarOptionChild[];
}

interface SideBarOptionChild {
  text: string;
  link: string;
}

export default class SideBarController {
  public static getSideBarModeratorOptions(): SideBarOption[] {
    return [
      {
        text: "My routine",
        icon: "mdi-road-variant",
        link: "",
        children: [
          { text: "Quản lý sản phẩm", link: "/my-routine/products" },
          { text: "Lịch sử người dùng", link: "/my-routine/users" },
        ],
      },
    ];
  }

  public static getSideBarAdminOptions(): SideBarOption[] {
    const adminOptions = this.getAdminOptions();
    const moderatorOptions = this.getSideBarModeratorOptions();
    moderatorOptions[0].children?.push(this.getMyRoutineUsersDownloadOption());
    return [...adminOptions, ...moderatorOptions];
  }

  private static getAdminOptions(): SideBarOption[] {
    return [
      {
        text: "Nhân sự",
        icon: "mdi-account-cog",
        link: "",
        children: [
          {
            text: "Quản lý nhân sự",
            link: "/admin/users",
          },
        ],
      },
    ];
  }

  private static getMyRoutineUsersDownloadOption(): SideBarOptionChild {
    return {
      text: "Tải lịch sử người dùng",
      link: "/my-routine/users-download",
    };
  }
}
